import React, {useState, useEffect} from 'react'
import SearchList from '../components/SearchList';
import firebase from '../firebase/config'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

export default function OtherAccount({countries}) {

    const tipoCuentas = ["Ahorro", "Corriente"]

    const [countriesSearched, setCountriesSearched] = useState([])
    const [pais, setPais] = useState("")

    const [banco, setBanco] = useState("")
    const [numeroMovil, setNumeroMovil] = useState("")
    const [dataBank, setDataBank] = useState({
        nombreTitular: "",
        nroCuenta: "",
        tipoCuenta: "",
        email: "",
        aba: "",
        swift: "",
        direccion: "",
        codigoPostal: "",
    })


    useEffect(() => {
        firebase.getCurrentUser()
    }, [])

    return (
        <div className="data-bank-account-container w-100">
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">País</span>
                <SearchList colLg={true} style={{ width: "100%" }} customOnClick={(e)=>{console.log(e)}} validate={true} valueListDefined={countries} statusValueLetter={setPais} valueLetter={pais} statusValueList={setCountriesSearched} valueList={countriesSearched.sort()}/>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Banco</span>
                <input type="text" className="form-control" value={banco} onChange={(e)=>{setBanco(e.target.value)}}/>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Nombre del titular</span>
                <input type="text" className="form-control" value={dataBank.nombreTitular} onChange={(e)=>{setDataBank({...dataBank, nombreTitular: e.target.value})}}/>
            </div>
            <div className="form-row px-3">
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">Nro. de cuenta</span>
                    <input type="text" className="form-control" value={dataBank.nroCuenta} onChange={(e)=>{setDataBank({...dataBank, nroCuenta: e.target.value})}}/>
                </div>
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">Tipo de cuenta</span>
                    <select className="form-control" value={dataBank.tipoCuenta} onChange={(e)=>{setDataBank({...dataBank, tipoCuenta: e.target.value})}}>
                        <option value="">Selecciona el tipo de cuenta</option>
                        <option value="Ahorro">Ahorro</option>
                        <option value="Corriente">Corriente</option>
                    </select>
                </div>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Correo electrónico</span>
                <input type="email" className="form-control" value={dataBank.email} onChange={(e)=>{setDataBank({...dataBank, email: e.target.value})}}/>
            </div>
            <div className="form-row px-3">
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">ABA</span>
                    <input type="text" className="form-control" value={dataBank.aba} onChange={(e)=>{setDataBank({...dataBank, aba: e.target.value})}}/>
                </div>
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">SWIFT</span>
                    <input type="text" className="form-control" value={dataBank.swift} onChange={(e)=>{setDataBank({...dataBank, swift: e.target.value})}}/>
                </div>
            </div>
            <div className="form-row px-3">
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">Dirección</span>
                    <input type="text" className="form-control" value={dataBank.direccion} onChange={(e)=>{setDataBank({...dataBank, direccion: e.target.value})}}/>
                </div>
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">Codigo postal</span>
                    <input type="text" className="form-control" value={dataBank.codigoPostal} onChange={(e)=>{setDataBank({...dataBank, codigoPostal: e.target.value})}}/>
                </div>
            </div>
          
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Número movil</span>
                <PhoneInput
                // defaultCountry={countryInfo.codigoTexto}
                value={numeroMovil} onChange={setNumeroMovil}/> 
            </div>
            <div className="row no-gutters justify-content-end">
                <div onClick={()=>{}} className="col-lg-5 btn btn-primary">Guardar datos bancarios</div>
            </div>
        </div>
    )
}
